import { Button } from "components/atoms/button/button";
import { Form } from "components/form-component/form/form";
import { MobileInput } from "components/form-component/mobile-input/mobile-input";
import React from "react";
import {
  FormHeading,
  FormSubHeading,
  MobileInputContainer,
  SendCTAWrapper
} from "./kelas-live-cmb-form.styles";
import { KelasLiveCMBStages } from "../kelas-live-cmb.types";
import { useKelasLiveCMBForm } from "./use-kelas-live-cmb-form";
import { KelasLiveCMBModal } from "../kelas-live-cmb-modal/kelas-live-cmb-modal";

const KelasLiveCMBForm: React.FC<{
  onClose: () => void;
  handleOnClick: (stage: KelasLiveCMBStages) => void;
  requestCallBack: (phoneNumber: string) => Promise<boolean>;
}> = ({ onClose, handleOnClick, requestCallBack }) => {
  const {
    control,
    isValid,
    handleSubmit,
    onSubmit,
    handleBack,
    handleClose,
    isLoading
  } = useKelasLiveCMBForm({
    handleCMBStage: handleOnClick,
    requestCallBack,
    onClose
  });

  return (
    <KelasLiveCMBModal isOpen={true} onClose={handleClose}>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <FormHeading>Tulis nomor kamu di sini, ya</FormHeading>
        <FormSubHeading>
          Nomor yang kamu pake buat login nggak <br />
          akan berubah, kok.
        </FormSubHeading>
        <MobileInputContainer>
          <MobileInput
            name={"phoneNumber"}
            placeholder={"81234..."}
            control={control}
          />
        </MobileInputContainer>
        <SendCTAWrapper>
          <Button
            type="submit"
            disabled={!isValid}
            variant="primary"
            isLoading={isLoading}
            loadingText="Kirim">
            Kirim
          </Button>
          <Button onClick={handleBack} variant="link">
            Kembali
          </Button>
        </SendCTAWrapper>
      </Form>
    </KelasLiveCMBModal>
  );
};

export { KelasLiveCMBForm };
